import React from 'react';
import CemitAppDependency from 'async/cemitAppAsync/CemitAppDependency.tsx';
import {useNotLoadingMemo} from 'utils/hooks/useMemoHooks.ts';
import {TrainAppOrganizationDependencyProps} from 'types/propTypes/appPropTypes/trainAppPropTypes/trainAppOrganizationDependencyProps.ts';

import HomePage from 'pages/profile/HomePage.tsx';
import OrganizationDependency from 'async/trainAppAsync/OrganizationDependency';
import TrainAppDependency from 'async/trainAppAsync/trainAppDependencies/TrainAppDependency';

/**
 * Wraps HomePage with organization context (without nesting multiple CemitAppDependency layers)
 */
const HomeAppDependency = () => {
  return (
    <CemitAppDependency appTitleKey="home">
      <TrainAppDependency
        organizationDependencyChildren={({
          appProps,
          organizationProps,
        }: TrainAppOrganizationDependencyProps) => {
          return useNotLoadingMemo(
            organizationProps.loading,
            (appProps, organizationProps) => (
              <HomePage {...{appProps, organizationProps}} />
            ),
            [appProps, organizationProps] as const
          );
        }}
      />
    </CemitAppDependency>
  );
};

export default HomeAppDependency;